var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentContainer"},[_c('img',{staticClass:"images-process",attrs:{"src":'../../../assets/applicationProcess/process' + _vm.imageid + '.svg',"alt":_vm.title_pro}}),_c('div',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title_pro))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description_pro))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }